import React from "react";

// components
import ResultItem from "./ResultItem/ResultItem";

// assets
import Strings from "../../assets/strings.json";

const Results = ({ form }) => {
  const fields = [];
  const getVal = (fields, name) => fields.filter((el) => el.name === name)[0];

  form.forEach((item) => {
    item.fields.forEach(({ name, resultName, title, value, options }) => {
      if (name !== "notEmergency") {
        fields.push({ name, resultName, title, value, options });
      }
    });
  });

  const results = [];

  fields.forEach((field) => {
    if (field.name === "category") {
      const cat = getVal(fields, "category");
      const selected = cat.options.filter((opt) => opt.label === cat.value)[0];

      results.push({
        title: field.resultName || field.title,
        value: selected.label,
        icon: selected.icon,
      });
    } else if (field.name === "images") {
      const images = field.value.length;

      if (images > 0) {
        results.push({
          name: field.name,
          title: field.resultName || field.title,
          value: field.value,
        });
      }
    } else if (field.name !== "acceptPP" && field.title) {
      results.push({
        title: field.resultName || field.title,
        value: field.value,
      });
    }
  });

  return (
    <div className="results mt-12 sm:mb-24 mb-12">
      <h2 className="result-title text-xl1/5 font-bold mt-0 mb-12">
        {Strings[document.body.dataset.lang].resultTitle}
      </h2>
      {results.map((result, i) => (
        <ResultItem key={`${result.name}-${i}`} {...result} />
      ))}
    </div>
  );
};

export default Results;
